import { apnsErrors } from './apns';

export const getFriendlyErrorMessage = (error: string): string => apnsErrors[error] ?? error;
